import React from 'react';
import { useGlobal } from 'reactn';
import { makeStyles } from '@material-ui/core/styles';
import './Sidebar.css';
import {
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from '@material-ui/core';
import clsx from 'clsx';
import HomeIcon from '@material-ui/icons/Home';
import LocationIcon from '@material-ui/icons/LocationOn';
import ChartIcon from '@material-ui/icons/InsertChartOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Link as RouterLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {setSelectedIndex} from "../../actions";



const drawerWidth = 255;
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex'
    },
    toolbar: {
        paddingRight: 24 // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    },
    menuButton: {
        marginRight: 36
    },
    menuButtonHidden: {
        display: 'none'
    },
    title: {
        flexGrow: 1
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        backgroundColor: theme.palette.primary.main,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9)
        }
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto'
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4)
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column'
    },
    fixedHeight: {
        height: 240
    },
    sidebarHeader: {
        overflow: 'hidden',
        backgroundColor: theme.palette.primary.kindaDark
    },
    listItem: {
        color: 'white',
        '&:hover': {
            color: 'white'
        },
        '& .MuiListItemIcon-root': {
            color: 'white'
        }
    },

    nested: {
        paddingLeft: theme.spacing(9),
    },
}));

const Sidebar = ({
    selectedIndex,
    setSelectedIndex
}) => {
    const classes = useStyles();
    const openState = {};
    const [sidebarOpen] = useGlobal('sidebarOpen');
    [openState.open0, openState.setOpen0] = React.useState(false);
    [openState.open1, openState.setOpen1] = React.useState(false);
    [openState.open2, openState.setOpen2] = React.useState(false);
    [openState.open3, openState.setOpen3] = React.useState(false);
    [openState.open4, openState.setOpen4] = React.useState(false);
    [openState.open5, openState.setOpen5] = React.useState(false);
    [openState.open6, openState.setOpen6] = React.useState(false);
    // const [selectedIndex, setSelectedIndex] = useGlobal('sidebarSelectedIndex');

    const [accountSubMenuOpen, setAccountSubMenuOpen] = React.useState(selectedIndex === 4 || selectedIndex === 5);

    const handleAccountSubMenuTriggerClick = (e) => {
        setAccountSubMenuOpen(!accountSubMenuOpen);
        // handleListItemClick(e, 4);
    };

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
        openState[`setOpen${index}`](!openState[`open${index}`]);
    };
    // const handleSidebarClose = () => {
    //     setSidebarOpen(false);
    // };

    return (
        <Drawer
            variant="permanent"
            classes={{
                paper: clsx(
                    classes.drawerPaper,
                    !sidebarOpen && classes.drawerPaperClose,
                )
            }}
            open={sidebarOpen}
        >
            <Grid
                container
                spacing={2}
                wrap="nowrap"
                justifyContent="space-between"
                className={classes.sidebarHeader}
            >
                <Grid item>
                    <img alt="GiftYa Logo" style={{ maxWidth: '190px', padding: '12px 11px 0px 14px' }} src="https://d2kn7nb9ubajli.cloudfront.net/logos/GY_Logo_horiz-white.png" />
                </Grid>
                {/*<Grid item>*/}
                {/*    <div className={classes.toolbarIcon}>*/}
                {/*        <IconButton onClick={handleSidebarClose}>*/}
                {/*            <ChevronLeftIcon />*/}
                {/*        </IconButton>*/}
                {/*    </div>*/}
                {/*</Grid>*/}
            </Grid>
            <List>
                <ListItem
                    button
                    to="/secure"
                    component={RouterLink}
                    selected={selectedIndex === 0}
                    className={classes.listItem}
                    onClick={event => handleListItemClick(event, 0)}
                >
                    <ListItemIcon>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Home" />
                </ListItem>
                <ListItem
                    button
                    to="/secure/customize"
                    component={RouterLink}
                    selected={selectedIndex === 1}
                    className={classes.listItem}
                    onClick={event => handleListItemClick(event, 1)}
                >
                    <ListItemIcon>
                        <LocationIcon />
                    </ListItemIcon>
                    <ListItemText primary="Customize" />
                </ListItem>
                <ListItem
                    button
                    to="/secure/locations"
                    component={RouterLink}
                    selected={selectedIndex === 2}
                    className={classes.listItem}
                    onClick={event => handleListItemClick(event, 2)}
                >
                    <ListItemIcon>
                        <LocationIcon />
                    </ListItemIcon>
                    <ListItemText primary="Locations" />
                </ListItem>
                <ListItem
                    button
                    to="/secure/reporting"
                    component={RouterLink}
                    selected={selectedIndex === 3}
                    className={classes.listItem}
                    onClick={event => handleListItemClick(event, 3)}
                >
                    <ListItemIcon>
                        <ChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Reporting" />
                </ListItem>






                <ListItem
                    button
                    to="/secure/reporting"
                    component={RouterLink}
                    selected={selectedIndex === 4 || selectedIndex === 5}
                    className={classes.listItem}
                    onClick={handleAccountSubMenuTriggerClick}
                >

                    <ListItemIcon>
                        <ChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Account" />
                    {accountSubMenuOpen ? <ExpandLess /> : <ExpandMore />}



                </ListItem>
                {accountSubMenuOpen && (
                    <List component="div" disablePadding>
                        <ListItem
                            button
                            to="/secure/account"
                            component={RouterLink}
                            selected={selectedIndex === 4}
                            className={`${classes.listItem} ${classes.nested}`}
                            onClick={event => handleListItemClick(event, 4)}
                        >
                            <ListItemText primary="My profile" />
                        </ListItem>
                        <ListItem
                            button
                            to="/secure/account/users"
                            component={RouterLink}
                            selected={selectedIndex === 5}
                            className={`${classes.listItem} ${classes.nested}`}
                            onClick={event => handleListItemClick(event, 5)}
                        >
                            <ListItemText primary="Manage users" />
                        </ListItem>
                        {/*<ListItem*/}
                        {/*    button*/}
                        {/*    to="/secure/account/users/manage"*/}
                        {/*    component={RouterLink}*/}
                        {/*    selected={selectedIndex === 4}*/}
                        {/*    className={`${classes.listItem} ${classes.nested}`}*/}
                        {/*    onClick={event => handleListItemClick(event, 4)}*/}
                        {/*>*/}
                        {/*    <ListItemText primary="Manage users" />*/}
                        {/*</ListItem>*/}
                    </List>
                )}









                <ListItem
                    button
                    to="/secure/contact"
                    component={RouterLink}
                    selected={selectedIndex === 6}
                    className={classes.listItem}
                    onClick={event => handleListItemClick(event, 6)}
                >
                    <ListItemIcon>
                        <HelpOutlineIcon />
                    </ListItemIcon>
                    <ListItemText primary="Help" />
                </ListItem>
            </List>
        </Drawer>
    );
}


export default connect(
    (state) => ({
        selectedIndex: state.app.selectedIndex
    }), {
        setSelectedIndex
    }
)(Sidebar);
